<template>
  <v-navigation-drawer
    app
    clipped
    fixed
    elevation="1"
    permanent
    width="60"
    style="border-right: 1px solid #ca0538"
  >
    <v-list class="py-0">
      <v-list-item-group v-model="model">
        <div v-for="(icon, i) in icons" :key="i">
          <v-list-item
            v-if="i < 2"
            style="background-color: #ca0538"
            class="px-0"
            active-class="icon_red_active"
            link
            :to="icon.link"
          >
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-content v-bind="attrs" v-on="on">
                  <v-icon v-text="icon.icon" color="white" large></v-icon>
                </v-list-item-content>
              </template>
              <span>{{ $t("navBar.tooltip." + icon.tooltip) }}</span>
            </v-tooltip>
          </v-list-item>
          <v-divider v-if="i == 2"></v-divider>
          <v-list-item v-if="i > 1" link :to="icon.link" class="px-0">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-content
                  v-bind="attrs"
                  v-on="on"
                  @click="goTo(icon.link)"
                >
                  <v-icon v-text="icon.icon" color="primary" large></v-icon>
                </v-list-item-content>
              </template>
              <span>{{ $t("navBar.tooltip." + icon.tooltip) }}</span>
            </v-tooltip>
          </v-list-item>
        </div>
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <div class="pa-2 caption text-center" style="color: #ca0538">
        v{{ version }}
      </div>
    </template>
  </v-navigation-drawer>
</template>

<style scoped>
.icon_red_active {
  opacity: 0.6;
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";
import { monitore } from "./helpers/helpers";
import { version } from "../../package.json";

export default {
  data: () => ({
    icons: [
      {
        id: 1,
        icon: "mdi-account",
        tooltip: "preferences",
        link: "/account",
      },
      {
        id: 2,
        icon: "mdi-heart",
        tooltip: "favorites",
        link: "/favorites",
      },
      {
        id: 3,
        icon: "mdi-home",
        tooltip: "home",
        link: "/",
      },
      {
        id: 4,
        icon: "mdi-magnify",
        tooltip: "search",
        link: "/search",
      },
      {
        id: 5,
        icon: "mdi-school",
        tooltip: "tutorial",
        link: "/tutorial",
      },
      {
        id: 6,
        icon: "mdi-email",
        tooltip: "contact",
        link: "/contact",
      },
      {
        id: 7,
        icon: "mdi-bookmark-multiple",
        tooltip: "links",
        link: "/links",
      },
      {
        id: 8,
        icon: "mdi-information-variant",
        tooltip: "about",
        link: "/about",
      },
    ],
    model: 1,
    version: version,
  }),
  computed: {
    ...mapGetters(["identity"]),
  },
  // TODO after 0.1.1 - REMOVE IF AUTHENTICATION WORKS FINE
  // async created() {
  //   if (!this.identity.sub) {
  //     await this.$authService.renewToken();
  //   }
  // },
  // beforeMount() {
  //   if (!this.identity.sub) {
  //     this.$authService.renewToken();
  //   }
  // },
  methods: {
    ...mapMutations([
      "resetLastPage",
      "resetCurrentPage",
      "setMultiRulesSelection",
    ]),
    goTo(link) {
      monitore("Show page", link);
      this.resetCurrentPage();
      this.resetLastPage();
      this.setMultiRulesSelection([]);
    },
  },
};
</script>